/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LootboxRedemption
 */
export interface LootboxRedemption {
    /**
     * 
     * @type {string}
     * @memberof LootboxRedemption
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof LootboxRedemption
     */
    lootboxName: string;
    /**
     * 
     * @type {string}
     * @memberof LootboxRedemption
     */
    prizeRevealName: string;
    /**
     * 
     * @type {string}
     * @memberof LootboxRedemption
     */
    transactionHash?: string;
    /**
     * 
     * @type {string}
     * @memberof LootboxRedemption
     */
    promoCode?: string;
    /**
     * 
     * @type {string}
     * @memberof LootboxRedemption
     */
    createdAt: string;
}

/**
 * Check if a given object implements the LootboxRedemption interface.
 */
export function instanceOfLootboxRedemption(value: object): value is LootboxRedemption {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('lootboxName' in value) || value['lootboxName'] === undefined) return false;
    if (!('prizeRevealName' in value) || value['prizeRevealName'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function LootboxRedemptionFromJSON(json: any): LootboxRedemption {
    return LootboxRedemptionFromJSONTyped(json, false);
}

export function LootboxRedemptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): LootboxRedemption {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'lootboxName': json['lootboxName'],
        'prizeRevealName': json['prizeRevealName'],
        'transactionHash': json['transactionHash'] == null ? undefined : json['transactionHash'],
        'promoCode': json['promoCode'] == null ? undefined : json['promoCode'],
        'createdAt': json['createdAt'],
    };
}

export function LootboxRedemptionToJSON(json: any): LootboxRedemption {
    return LootboxRedemptionToJSONTyped(json, false);
}

export function LootboxRedemptionToJSONTyped(value?: LootboxRedemption | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'lootboxName': value['lootboxName'],
        'prizeRevealName': value['prizeRevealName'],
        'transactionHash': value['transactionHash'],
        'promoCode': value['promoCode'],
        'createdAt': value['createdAt'],
    };
}

